// Clients
import { UserItem } from '../../../clients/BackendAdminClient/nonsc-user'

// References
export { UserItem } from '../../../clients/BackendAdminClient/nonsc-user'

/**
 * Import item properties
 * @typedef UserInput
 * @type {Object}
 * @property {Number} [id]      - User ID
 * @property {String} [homeId]  - Home DI
 * @property {String} firstName - First name
 * @property {String} lastName  - Last name
 * @property {String} role      - OWNER, RESIDENT, and RENTER
 * @property {String} mobileNo  - Mobile number
 * @property {String} email     - Email
 */

export class NonScUserCommon {
  
  /** @type {UserInput} */
  static input = {
    id        : null,
    firstName : null,
    lastName  : null,
    role      : 'OWNER',
    mobileNo  : null,
    email     : null,
  }

  /** @type {UserItem} */
  static item = {
    id        : null,
    name      : null,
    role      : null,
    home      : null,
    project   : null,
    mobileNo  : null,
    email     : null,
  }
}


// WEBPACK FOOTER //
// ./src/features/nonsc/common/nonsc-user.common.js